<template>
  <v-app>
    <navbar v-if="isAuthenticated"></navbar>

    <v-main>
      <v-container fluid class="px-8 py-6">
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';

import Navbar from './components/Navbar';


export default {
  name: 'app',
  components: {
    Navbar,
  },
  computed: mapGetters('auth', [
    'isAuthenticated',
  ]),
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600');
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Material+Icons');
@import url('https://use.fontawesome.com/releases/v5.0.7/css/all.css');

#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #FEFEFE;
}

/*
.v-application--wrap {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
}
*/

.v-app-bar__nav-icon {
  margin-left: 0 !important;
}

.v-toolbar__title {
  font-size: 1.5rem !important;
  font-weight: 500 !important;
  padding-left: 12px !important;
}

html {
  overflow-y: auto;
}

h2 {
  font-size: 18pt;
  font-weight: 600;
  margin-bottom: 18px;
}

h3 {
  font-size: 14pt;
  font-weight: 500;
  margin-bottom: 16px;
}

.v-btn__content {
  font-weight: 500;
  font-size: 11pt;
}

button.bold .v-btn__content, button.primary .v-btn__content {
  font-weight: 900;
  letter-spacing: 1pt;
  font-size: 12pt;
}

.v-application p {
  margin-bottom: 10px;
}

table caption {
  margin: 15px auto;
  font-weight: 600;
}

.columns-visibility-toggle-container {
  margin-bottom: 18px;
}

.toggles-visibility-control {
  font-size: 25pt;
  line-height: 0.8;
}

.toggles-header h3 {
  margin-right: 15px;
  margin-bottom: 0;
}

.toggles-header button {
  height: 20px;
  width: 20px;
}

.toggles-header {
  display: flex;
  margin-top: 0;
  margin-bottom: 5px;
}

.window-portal .toggles-header {
  margin-top: 0;
}

.columns-visibility-toggle-list {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
}

.column-visibility-toggle .v-input--checkbox {
  padding: 0;
  margin-top: 0;
}

.column-visibility-toggle {
  display: flex;
  margin-bottom: 3px;
  margin-right: 10px;
  width: min-content;
  white-space: nowrap;
}

.column-visibility-toggle .v-input--selection-controls__input {
  margin-right: 4px;
}


</style>



// WEBPACK FOOTER //
// src/App.vue